import { commonLocale } from "./common";
const locale = {
  ...commonLocale,
  locale: 'km',
  today: 'ថ្ងៃនេះ',
  now: 'ឥឡូវ​នេះ',
  backToToday: 'ត្រលប់ទៅថ្ងៃនេះ',
  ok: 'កំណត់',
  timeSelect: 'រយៈពេលជ្រើសរើស',
  dateSelect: 'ជ្រើសរើសកាលបរិច្ឆេទ',
  weekSelect: 'ជ្រើសរើសសប្តាហ៍',
  clear: 'ច្បាស់',
  week: 'សប្តាហ៍',
  month: 'ខែ',
  year: 'ឆ្នាំ',
  previousMonth: 'ខែមុន',
  nextMonth: 'ខែបន្ទាប់',
  monthSelect: 'ជ្រើសរើសខែ',
  yearSelect: 'ជ្រើសរើសឆ្នាំ',
  decadeSelect: 'ជ្រើសរើសអាយុ',
  previousYear: 'ឆ្នាំមុន',
  nextYear: 'ឆ្នាំក្រោយ',
  previousDecade: 'ជំនាន់ចុងក្រោយ',
  nextDecade: 'ជំនាន់​ក្រោយ',
  previousCentury: 'សតវត្សចុងក្រោយ',
  nextCentury: 'សតវត្សរ៍បន្ទាប់',
  monthBeforeYear: false
};
export default locale;